import { NAMED_GRAPH_LIMIT } from 'src/constants/limits';
import { ALL_NAMED_GRAPH_IRI } from 'src/templates/queries/iris';

export type NamedGraphBinding = {
  graph?: {
    type: 'uri';
    value: string;
  };
  alias?: {
    type: 'uri';
    value: string;
  };
};

/**
 * Determines the available named graphs and named graph aliases for a given database.
 *
 * Populates the Named Graph selector in the Settings dialog.
 *
 * **Call Frequency**
 *
 * This query is called for each database whenever the current connection changes.
 *
 * **Context**
 * - Named graphs: always the default named graph (none specified)
 * - Reasoning: always off
 *
 * **Example**
 * ```sparql
# Named Graphs (graph + aliases)
SELECT DISTINCT
  ?graph
  ?alias
FROM NAMED <tag:stardog:api:context:all>
WHERE {
  {
    SELECT DISTINCT ?graph {
      GRAPH ?graph { }
      FILTER (?graph NOT IN (<tag:stardog:api:graph:aliases>, <tag:stardog:api:sql:schema>))
      FILTER (!STRSTARTS(STR(?graph), 'virtual://'))
    }
    LIMIT 100
  } UNION {
    SELECT DISTINCT ?graph {
      GRAPH ?graph { }
      FILTER (STRSTARTS(STR(?graph), 'virtual://'))
    }
    LIMIT 100
  } UNION {
    {
      SELECT DISTINCT ?graph {
        GRAPH <tag:stardog:api:graph:aliases> {
          ?graph <tag:stardog:api:graph:alias> ?alias
        }
      }
      LIMIT 100
    }
    GRAPH <tag:stardog:api:graph:aliases> {
      ?graph <tag:stardog:api:graph:alias> ?alias
    }
  }
}
ORDER BY ?graph
 * ```
 */
export const getNamedGraphsQuery = `# Named Graphs (graph + aliases)
SELECT DISTINCT
  ?graph
  ?alias
FROM NAMED <${ALL_NAMED_GRAPH_IRI}>
WHERE {
  {
    SELECT DISTINCT ?graph {
      GRAPH ?graph { }
      FILTER (?graph NOT IN (<tag:stardog:api:graph:aliases>, <tag:stardog:api:sql:schema>))
      FILTER (!STRSTARTS(STR(?graph), 'virtual://'))
    }
    LIMIT ${NAMED_GRAPH_LIMIT}
  } UNION {
    SELECT DISTINCT ?graph {
      GRAPH ?graph { }
      FILTER (STRSTARTS(STR(?graph), 'virtual://'))
    }
    LIMIT ${NAMED_GRAPH_LIMIT}
  } UNION {
    {
      SELECT DISTINCT ?graph {
        GRAPH <tag:stardog:api:graph:aliases> {
          ?graph <tag:stardog:api:graph:alias> ?alias
        }
      }
      LIMIT ${NAMED_GRAPH_LIMIT}
    }
    GRAPH <tag:stardog:api:graph:aliases> {
      ?graph <tag:stardog:api:graph:alias> ?alias
    }
  }
}
ORDER BY ?graph
`;
